/* Carnis – «Gjør det til en 3-pakk» i handlekurven (nov. 2026, v1).
   Markup: snippets/carnis-kurv-3pakk.liquid (skuffen og handlekurvsiden). Lastes fra snippets/cart-drawer.liquid og
   sections/main-cart-footer.liquid (bare én gang).
   - plan(cart, cfg) er en ren funksjon (ingen DOM, ingen nettverk) med de samme reglene som snippeten:
     engangslinjer uten linjerabatt med Storfetalg (t) og Organmix (o); Carnis-pakken = 1 t + 1 o; 3-pakk-linjer telles
     ikke; ikke forhandlerkurver eller rabattkoder. n = 1–2: fyll opp med det kunden har mest av (likt: Storfetalg);
     n = 3: bytt bare når 3-pakken er billigere enn linjene nå (final_line_price); n > 3: ingenting.
     Alle tall kommer fra Shopify (cfg: variantene på 3-pakken og engangsprisene, cart.js: final_line_price).
   - Ett trykk: leser kurven på nytt og regner planen igjen (kurven kan ha endret seg, f.eks. når carnis-pakke-kurv.js
     slår sammen talg + Organmix til Carnis-pakken). Stemmer den ikke med tilbudet som vises, tegnes kurven bare på nytt.
     Ellers: legg 1 × 3-pakk-varianten i kurven (cart/add.js), fjern linjene (cart/change.js, quantity 0 per linjenøkkel).
     Feiler noe, rulles det tilbake (3-pakken tas ut igjen, fjernede linjer legges inn igjen) og en feilmelding vises.
     Skuffen tegnes på nytt (PUB_SUB_EVENTS.cartUpdate + renderContents), handlekurvsiden lastes på nytt.
   - Samspill med assets/carnis-pakke-kurv.js: 3-pakken er verken pakken eller en av komponentene, så pakkeskriptet rører
     den aldri. Etter byttet ligger ingen telte talg/Organmix-linjer igjen, så det er ingenting å slå sammen (ingen ping-pong).
   Ingen avhengigheter utover temaets pubsub.js og cart-drawer.js. */
(function (root) {
  'use strict';

  function discounted(it) {
    return (it.line_level_discount_allocations || []).some(function (a) { return Number(a && a.amount) > 0; });
  }
  function usesCode(cart) {
    var c = (cart.cart_level_discount_applications || []).some(function (d) { return d && d.type === 'discount_code'; });
    return c || (cart.items || []).some(function (it) {
      return (it.line_level_discount_allocations || []).some(function (a) {
        return a && a.discount_application && a.discount_application.type === 'discount_code';
      });
    });
  }

  // Ren utregning. cart = /cart.js, cfg = {th, oh, ph (håndtak), tp, op (engangspris i øre), v: [{id,t,o,price,available,title}]}
  function plan(cart, cfg) {
    if (!cart || !cfg || !cfg.v || !cfg.v.length) return null;
    var tp = Number(cfg.tp) || 0, op = Number(cfg.op) || 0;
    if (tp <= 0 || op <= 0) return null;
    var items = cart.items || [];
    var t = 0, o = 0, cur = 0, lines = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var h = String(it.handle || '');
      if (h.indexOf('forhandler') > -1) return null;
      if (it.selling_plan_allocation || discounted(it)) continue;
      var kt = 0, ko = 0;
      if (h === cfg.th) kt = 1;
      else if (h === cfg.oh) ko = 1;
      else if (h === cfg.ph) { kt = 1; ko = 1; }
      else continue;
      var q = Number(it.quantity) || 0;
      if (q <= 0) continue;
      t += kt * q;
      o += ko * q;
      cur += Number(it.final_line_price) || 0;
      lines.push({ key: it.key, id: it.variant_id, quantity: q, properties: it.properties || null });
    }
    if (usesCode(cart)) return null;
    var n = t + o;
    if (n < 1 || n > 3) return null;
    var addN = 3 - n, wt = t, wo = o, addKind = '', addOnce = 0;
    if (addN > 0) {
      if (t >= o) { wt += addN; addKind = 't'; addOnce = addN * tp; }
      else { wo += addN; addKind = 'o'; addOnce = addN * op; }
    }
    var v = null;
    cfg.v.forEach(function (x) {
      if (!v && Number(x.t) === wt && Number(x.o) === wo && x.available !== false) v = x;
    });
    if (!v) return null;
    var price = Number(v.price) || 0;
    if (price <= 0) return null;
    var sep = wt * tp + wo * op - price; // spar mot hver for seg
    var out = { mode: '', target: Number(v.id), title: v.title || '', price: price, cur: cur, sep: sep, n: n, t: wt, o: wo, addN: addN, addKind: addKind, lines: lines };
    if (addN === 0) {
      out.save = cur - price;
      if (out.save <= 0) return null;
      out.mode = 'swap';
      return out;
    }
    out.extra = price - cur;
    if (sep <= 0 || out.extra <= 0 || price >= cur + addOnce) return null;
    out.mode = 'fill';
    return out;
  }

  var api = { plan: plan };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined' || !root) return;
  if (root.CarnisKurv3pk) return;
  root.CarnisKurv3pk = api;

  var R = root.routes || {};
  var URL_CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var URL_ADD = (R.cart_add_url || '/cart/add') + '.js';
  var URL_CART = (R.cart_url || '/cart') + '.js';
  var ERR_KEY = 'carnis-3pk-feil';
  var MSG = 'Kunne ikke gjøre det om til 3-pakk akkurat nå. Prøv igjen.';
  var running = false;
  var pendingMsg = '';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart');
        return j;
      });
    });
  }
  // Venter til carnis-pakke-kurv.js er ferdig med en eventuell endring (maks ca. 4 s)
  function waitIdle() {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        var pk = root.CarnisPakkeKurv;
        if (!pk || typeof pk.busy !== 'function' || !pk.busy() || tries++ > 20) { resolve(); return; }
        setTimeout(check, 200);
      })();
    });
  }
  function getCart() {
    return fetch(URL_CART, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function onCartPage() {
    var p = root.location.pathname.replace(/\/$/, '');
    return p === (R.cart_url || '/cart').replace(/\/$/, '');
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.classList.toggle('is-loading', on);
  }
  function showMsg(box, msg) {
    var err = box && box.querySelector('[data-ckv-3pk-err]');
    if (!err) return false;
    err.textContent = msg;
    err.hidden = false;
    return true;
  }
  // Feilmelding som skal stå etter at kurven er tegnet på nytt
  function remember(msg) {
    pendingMsg = msg;
    try { root.sessionStorage.setItem(ERR_KEY, JSON.stringify({ t: Date.now(), msg: msg })); } catch (e) {}
  }
  function paint() {
    var msg = pendingMsg;
    if (!msg) {
      try {
        var r = JSON.parse(root.sessionStorage.getItem(ERR_KEY) || 'null');
        if (r && r.t && Date.now() - r.t < 60 * 1000) msg = r.msg;
      } catch (e) {}
    }
    if (!msg) return;
    var shown = false;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ckv-3pk]'), function (box) {
      if (showMsg(box, msg)) shown = true;
    });
    if (shown) {
      pendingMsg = '';
      try { root.sessionStorage.removeItem(ERR_KEY); } catch (e) {}
    }
  }

  // Tegner kurven på nytt etter endringen
  function refresh(cart) {
    if (onCartPage()) { root.location.reload(); return Promise.resolve(); }
    var drawer = document.querySelector('cart-drawer');
    var pub = false;
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carnis-kurv-3pakk', cartData: cart });
        pub = true;
      }
    } catch (e) {}
    if (drawer && typeof drawer.renderContents === 'function') {
      return fetch(root.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          if (!sections || !sections['cart-drawer']) throw new Error('sections');
          drawer.renderContents({ sections: sections });
        })
        .catch(function () { if (!pub) root.location.reload(); });
    }
    if (!pub) root.location.reload();
    return Promise.resolve();
  }

  // Legger kurven tilbake slik den var: 3-pakken ut igjen, fjernede linjer inn igjen
  function rollback(addedKey, removed) {
    return getCart().then(function (cart) {
      var chain = Promise.resolve();
      var line = null;
      (cart.items || []).forEach(function (it) { if (!line && it.key === addedKey) line = it; });
      if (line) {
        chain = chain.then(function () { return post(URL_CHANGE, { id: line.key, quantity: Math.max(0, line.quantity - 1) }); });
      }
      if (removed.length) {
        chain = chain.then(function () {
          return post(URL_ADD, {
            items: removed.map(function (l) {
              var x = { id: l.id, quantity: l.quantity };
              if (l.properties && Object.keys(l.properties).length) x.properties = l.properties;
              return x;
            })
          });
        });
      }
      return chain;
    });
  }

  function execute(p) {
    var addedKey = null;
    var removed = [];
    return post(URL_ADD, { items: [{ id: p.target, quantity: 1 }] }).catch(function (err) {
      // Ingenting er endret ennå
      err.rolledBack = true;
      throw err;
    }).then(function (res) {
      var it = res && res.items && res.items[0];
      addedKey = it ? it.key : null;
      var chain = Promise.resolve();
      p.lines.forEach(function (l) {
        chain = chain.then(function () {
          return post(URL_CHANGE, { id: l.key, quantity: 0 }).then(function () { removed.push(l); });
        });
      });
      return chain.then(getCart).catch(function (err) {
        // Ikke la kurven stå halvveis
        return rollback(addedKey, removed).then(function () { err.rolledBack = true; throw err; }, function () { throw err; });
      });
    });
  }

  function go(btn) {
    if (running) return;
    var box = btn.closest('[data-ckv-3pk]');
    var cfgEl = box && box.querySelector('[data-ckv-3pk-cfg]');
    var cfg = null;
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : 'null'); } catch (e) { cfg = null; }
    var want = Number(btn.getAttribute('data-target')) || 0;
    if (!cfg || !want) return;
    running = true;
    busy(btn, true);
    var err0 = box.querySelector('[data-ckv-3pk-err]');
    if (err0) err0.hidden = true;
    waitIdle().then(getCart).then(function (cart) {
      var p = plan(cart, cfg);
      // Kurven har endret seg siden tilbudet ble vist: vis det som gjelder nå, uten å endre noe
      if (!p || p.target !== want) return refresh(cart);
      // Pakkeskriptet (carnis-pakke-kurv.js) venter mens kurven endres her
      root.__carnis3pkBusy = true;
      return execute(p).then(function (after) {
        root.__carnis3pkBusy = false;
        return refresh(after);
      }, function (err) {
        root.__carnis3pkBusy = false;
        throw err;
      });
    }).catch(function (err) {
      if (err && err.rolledBack) {
        // Kurven er som før: vis feilen her
        busy(btn, false);
        if (!showMsg(box, MSG)) { remember(MSG); }
        return;
      }
      // Kan ha endret noe: tegn kurven på nytt og vis feilen etterpå
      remember(MSG);
      return getCart().then(function (c) { return refresh(c); }).catch(function () { busy(btn, false); paint(); });
    }).then(function () {
      running = false;
    }, function () {
      running = false;
      busy(btn, false);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ckv-3pk-go]') : null;
    if (!t || t.disabled) return;
    e.preventDefault();
    go(t);
  });

  function watch() {
    paint();
    if (!('MutationObserver' in root)) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending || (!pendingMsg && !hasStored())) return;
      pending = true;
      root.requestAnimationFrame(function () { pending = false; paint(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  function hasStored() {
    try { return !!root.sessionStorage.getItem(ERR_KEY); } catch (e) { return false; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})(typeof window !== 'undefined' ? window : null);
